import { render, staticRenderFns } from "./ExternalSftpConfiguration.vue?vue&type=template&id=2312f8c8&lang=pug&"
import script from "./ExternalSftpConfiguration.vue?vue&type=script&lang=ts&"
export * from "./ExternalSftpConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports